import request from '@/utils/request'

// 获取品牌列表
export const getBrandLists = (data) => {
    return request({
        url: '/brand/lists',
        params: data
    })
}

// 品牌-详情
export const getBrandDetail = (id) => {
    return request({
        url: `/brand/${id}`
    })
}

// 品牌-修改
export const putBrandModel = (data) => {
    return request({
        url: '/brand/manage',
        method: 'PUT',
        data
    })
}

// 品牌-添加
export const addBrandModel = (data) => {
    return request({
        url: '/brand/manage',
        method: 'POST',
        data
    })
}

// 品牌-删除
export const delBrandModel = (id) => {
    return request({
        url: `/brand/${id}`,
        method: 'DELETE'
    })
}
// 批量处理品牌
export const batchBrandModel = (method, data) => {
    return request({
        url: '/brand/manage',
        method: 'PATCH',
        data: {
            method,
            data
        }
    })
}

// 品牌-设置详情
export const getSettingDetail = (id) => {
    return request({
        url: `/equip/setting/${id}`
    })
}

// 品牌-设置参数
export const postSetting = (id, data) => {
    return request({
        url: `/equip/setting/${id}`,
        method: 'POST',
        data
    })
}

// 品牌-清除参数设置
export const removeSetting = (id) => {
    return request({
        url: `/equip/setting/${id}`,
        method: 'DELETE'
    })
}

/**
 * 品牌--品牌选项
 */
export const getBrandOption = () => {
    return request({
        url: '/brand/option/lists'
    })
}

// 根据型号获取字段信息
export const getEquipModelFieldLists = (data) => {
    return request({
        url: '/brand/field/lists',
        params: data
    })
}

/**
 * 下载导入模板
 */
export const getEquipModelTemplateUrl = () => {
    return request({
        url: '/brand/excel/imports'
    })
}

// 品牌-导出
export const importsEquipModel = (data) => {
    return request({
        url: '/brand/excel/imports',
        method: 'POST',
        data
    })
}

/**
 * 下载品牌导入模板
 */
export const getBrandTemplateUrl = () => {
    return request({
        url: '/brand/excel/imports'
    })
}
// 品牌-导入
export const importsBrand = (data) => {
    return request({
        url: '/brand/excel/imports',
        method: 'POST',
        data
    })
}
